import { useState } from 'react';

const faqs = [
  {
    q: 'Wie schnell erhalte ich ein Angebot?',
    a: 'In der Regel erstellen wir Ihr kostenloses Festpreisangebot innerhalb von 24 Stunden nach Ihrer Anfrage. Bei größeren Projekten vereinbaren wir gerne einen Vor-Ort-Termin für eine präzise Kalkulation.',
  },
  {
    q: 'In welchem Gebiet sind Sie tätig?',
    a: 'Wir sind hauptsächlich in der Region Rhein-Ruhr tätig – dazu gehören Ratingen, Düsseldorf, Mettmann, Velbert, Wuppertal, Solingen, Remscheid und umliegende Kreise. Für Großprojekte sind wir auch NRW-weit aktiv.',
  },
  {
    q: 'Bieten Sie auch Einzelgewerke an?',
    a: 'Ja! Neben schlüsselfertigen Gesamtprojekten führen wir auch Einzelgewerke durch – ob nur Trockenbau, Bodenbeläge oder reine Gartenarbeiten. Sprechen Sie uns einfach an.',
  },
  {
    q: 'Gibt es eine Festpreisgarantie?',
    a: 'Ja. Sobald das Angebot vereinbart und unterzeichnet ist, gilt ein verbindlicher Festpreis. Keine versteckten Kosten, keine Nachforderungen – außer bei expliziten Änderungswünschen Ihrerseits.',
  },
  {
    q: 'Wie läuft ein typisches Projekt ab?',
    a: 'Nach Ihrer Anfrage folgt eine Beratung (telefonisch oder vor Ort), dann ein schriftliches Angebot. Nach Auftragserteilung planen wir Termine, beschaffen Material und führen die Arbeiten durch. Am Ende übergeben wir das fertige Werk mit Abnahmeprotokoll.',
  },
  {
    q: 'Übernehmen Sie auch die Entsorgung von Baumaterialien?',
    a: 'Ja, auf Wunsch übernehmen wir die fachgerechte Entsorgung von Abbruchmaterial, Bauschutt und Altmaterialien. Dies kann optional im Angebot berücksichtigt werden.',
  },
];

export default function KontaktFAQ() {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <section className="py-16 sm:py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="inline-block text-[#C8A96E] text-sm font-semibold tracking-widest uppercase mb-3">FAQ</span>
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900">Häufig gestellte Fragen</h2>
          <p className="text-gray-500 mt-3 text-sm max-w-xl mx-auto">
            Hier finden Sie Antworten auf die häufigsten Fragen zu unserer Arbeit und unserem Prozess.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className={`rounded-xl border transition-all duration-200 overflow-hidden ${
                open === idx ? 'border-[#0D2B4E]/30 bg-[#0D2B4E]/[0.03]' : 'border-gray-200 bg-white'
              }`}
            >
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                onClick={() => setOpen(open === idx ? null : idx)}
              >
                <span className={`font-semibold text-sm sm:text-base pr-4 ${open === idx ? 'text-[#0D2B4E]' : 'text-gray-900'}`}>
                  {faq.q}
                </span>
                <div className={`w-7 h-7 flex items-center justify-center flex-shrink-0 rounded-full transition-all ${open === idx ? 'bg-[#0D2B4E] rotate-45' : 'bg-gray-100'}`}>
                  <i className={`ri-add-line text-base ${open === idx ? 'text-white' : 'text-gray-600'}`} />
                </div>
              </button>
              {open === idx && (
                <div className="px-5 pb-5">
                  <p className="text-gray-600 text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
